export default __webpack_public_path__ + "static/media/noimage-writer.25abdf70.svg";